import { render, staticRenderFns } from "./ColorBox.vue?vue&type=template&id=209ecfe8&scoped=true"
import script from "./ColorBox.vue?vue&type=script&lang=ts"
export * from "./ColorBox.vue?vue&type=script&lang=ts"
import style0 from "./ColorBox.vue?vue&type=style&index=0&id=209ecfe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209ecfe8",
  null
  
)

export default component.exports